<template>
    <div class="inner-wrap">
        <div class="left" :style="{'height': height}">
            <template v-if="special_tech_list.length>0">
                <h1>Special Process Selection</h1>
                <template v-if="form_data.special_tech.length>0">
                    <div class="tech-list">
                        <div class="tech-item"
                             v-for="(v,k) in this.special_tech_list.filter(vv=>form_data.special_tech.includes(vv.id))"
                             :key="`te`+k"
                        >
                            <span class="name">{{ v.name }}</span>
                            <span class="money" v-show="tech_price[v.id]>0">${{tech_price[v.id]|price_format}}</span>
                            <img src="@/assets/images/design/icon-del.png" alt="" class="check cursor" @click="toggle_special_tech(v)">
                        </div>
                    </div>
                </template>
                <template v-else>
                    <p class="tip">If needed, please select special processes on the right</p>
                </template>

            </template>

            <h1>Upload Your Process Illustration Images and Files</h1>
            <div v-for="(v, k) in form_data.tech" :key="`tech` + k" class="item">
                <Upload
                        :action="upload_url" :data="{ dir: 'template' }"
                        :before-upload="(file)=>onBeforeUpload(file, 'tech',k,'file')"
                        :show-upload-list="false"
                >
                    <template v-if="!!!v.raw">
                        <div class="upload-wrap cursor">
                            <img class="icon-upload" src="@/assets/images/design/icon-upload-pink.png"/>
                            <p>Click to Upload Process Illustration Image/File</p>
                        </div>
                    </template>
                    <template v-else-if="util.test_image(v.raw)">
                        <div class="image-box">
                            <img @click.stop :src="v.raw" class="" style="width:100%;height: 100%;object-fit:contain;" v-viewer />
                            <div class="replace-btn">
                                <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                <div class="text">Re-upload</div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="doc-file">
                        <a class="doc-wrap" target="_blank" :href="v.raw" @click.stop>
                            <img :src="util.get_image_icon(v.raw_name)" class="icon-doc" />
                            <span>{{v.raw_name}}</span>
                        </a>
                        <div class="replace-file">
                                <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                <div class="text">Re-upload</div>
                            </div>
                        </div>
                    </template>
                </Upload>
                <div class="bz">
                    <label >Remarks:</label>
                    <input :value="form_data.tech[k].content" @input="input($event, 'tech', k)"  placeholder="Please enter remarks" />
                </div>
                <img src="@/assets/images/design/icon-del2.png" alt="" class="icon-del cursor" @click.stop="del_tech(k)">
            </div>
            <div class="btn btn-continue cursor" @click="add_tech">+ Add Process Illustration</div>
        </div>

        <div class="right" :style="{width: width}" >
            <template v-if="is_lesson_show">
                <Lesson ></Lesson>
            </template>
            <template v-else>
                <!--  :style="{'height': height, overflow: 'auto'}" -->
                <div class="material-wrap">
                    <div class="top">
                        <h2>Special Process Selection</h2>
                        <div class="input-wrap">
                            <input v-model="form_data_special_tech.keyword" placeholder="Enter keywords to search special processes" type="text" @keyup.enter="search_special_tech"/>
                            <img alt="" class="icon-search" src="@/assets/images/icon-search.png" @click="search_special_tech"/>
                        </div>
                    </div>
                    <div class="content">
                        <div class="right">
                            <template v-if="special_tech_list.length > 0">
                                <div class="fabric-list">
                                    <div
                                            v-for="(v, k) in special_tech_list"
                                            :key="`df` + k"
                                            :class="{ active: form_data.special_tech.includes(v.id) }"
                                            class="fabric-item"
                                            @click="toggle_special_tech(v)"
                                    >
                                        <img :src="v.image | default_img" alt="" />
                                        <p>{{ v.name }}</p>
                                        <img v-show="form_data.special_tech.includes(v.id)" alt="" class="icon-check" src="@/assets/images/icon-check.png"/>
                                        <div class="mask">
                                            <div class="btn">
                                                <span class="fa-detail" @click.stop="open_tech_detail(v)">View</span>
                                                <span class="fa-choose" @click.stop="toggle_special_tech(v)">{{form_data.special_tech.includes(v.id)?'Cancel':'Select'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Page :current="form_data_special_tech.page" v-if="total>0" :page-size="form_data_special_tech.size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  ></Page>
                            </template>
                            <template v-else>
                                <img class="no-data" :src="require(`@/assets/images/no-data.png`)" alt="">
                            </template>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <popup :show.sync="is_popup_show_detail" height="680px" width="980px">
            <div class="fabric-content-wrap">
                <div class="title">{{ current_temp_special_tech.name }}</div>
                <div class="content-scroll">
                <div class="info-wrap" v-if="current_temp_special_tech.video">
                    <video :src="current_temp_special_tech.video" controls autoplay muted style="object-fit:contain;width:100%;height:300px;"></video>
                    <!-- <div class="left">
                        <div v-if="current_temp_special_tech.image_list.length > 0" class="slider">
                            <swiper ref="swiper" :options="swiperOption">
                                <swiper-slide
                                        v-for="(item, index) in current_temp_special_tech.image_list"
                                        :key="`sl` + index"
                                >
                                    <img :src="item.url" class="img" />
                                </swiper-slide>
                                <div slot="button-prev" class="swiper-button-prev"></div>
                                <div slot="button-next" class="swiper-button-next"></div>
                            </swiper>
                        </div>
                    </div> -->
                    <!-- <div class="right">
                        <p class="name">{{ current_temp_special_tech.name }}</p>
                    </div> -->
                </div>
                <!-- <div class="title">详情</div> -->
                <div class="richtext-wrap" v-html="current_temp_special_tech.content"></div>
            </div>
            </div>
        </popup>
    </div>
</template>

<script>
    import util from '@/utils/util'
    import {mapState} from 'vuex'
    import {
       GetSpecialTech
    } from "@/api/index.js";
    import Popup from "@/components/Popup.vue";
    import "swiper/dist/css/swiper.css";
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import Lesson from "./Lesson.vue";
    import { uploadFileToOSS } from "@/utils/oss";
    export default {
        name: "Tech",
        data() {
            return {
                swiperOption: {
                    loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    observer: true, //修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true, //修改swiper的父元素时，自动初始化swiper
                },
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
                util: util,
                form_data_special_tech: {
                    page: 1,
                    size: 20,
                    keyword: "",
                    tech_id: []
                },
                total: -1,
                special_tech_list: [],
                current_temp_special_tech: {
                    image_list: []
                },
                is_popup_show_detail: false,
                tech_list: [],
                tech_price: {},
                sub_product_category_list: [],
                width: '600px'
            }
        },
        components: {
            Popup,
            swiper,
            swiperSlide,
            Lesson
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                height: (state) => state.design.height,
                is_lesson_show: (state) => state.design.is_lesson_show,
                product_category_list: (state) => state.design.product_category_list,
            }),
        },
        watch: {
            "form_data.parent_product_category_id": {
                handler(newVal, oldVal) {
                    if (newVal > 0) {
                        let obj = this.product_category_list.find((v) => v.product_category_id === newVal);
                        this.sub_product_category_list = obj.children;
                        this.tech_list = obj.tech_list;
                        this.tech_price = {}
                        for(let i in obj.tech_price) {
                            this.$set(this.tech_price, obj.tech_price[i].tech_id, obj.tech_price[i].price)
                        }
                        if (oldVal > 0) {
                            this.form_data.child_product_category_id = 0;
                            this.$store.commit('design/clear_special_tech')
                        }
                        this.form_data_special_tech.tech_id = this.tech_list.map(v=>v.id)
                        this.getSpecialTechList()
                    }
                },
                immediate: true, // 立即执行一次handler以初始化数据
                deep: true, // 深度监听（虽然在这个场景下可能不是必需的）
            },
            "form_data.child_product_category_id": {
                handler(newVal, oldVal) {
                    if (newVal > 0) {
                        let obj = this.product_category_list.find((v) => v.product_category_id === this.form_data.parent_product_category_id);
                        let children = obj?.children;
                        if (children) {
                            let child = this.sub_product_category_list.find((v) => v.product_category_id === newVal);
                            this.tech_list = child?.tech_list;
                            this.tech_price = {}
                            for(let i in child.tech_price) {
                                this.$set(this.tech_price, child.tech_price[i].tech_id, child.tech_price[i].price)
                            }
                            if (oldVal > 0) {
                                this.$store.commit('design/clear_special_tech')
                            }
                            this.form_data_special_tech.tech_id = this.tech_list.map(v=>v.id)
                            this.getSpecialTechList()
                        }
                    }
                },
                immediate: true, // 立即执行一次handler以初始化数据
                deep: true, // 深度监听（虽然在这个场景下可能不是必需的）
            },
        },
        methods: {
            changePage(page) {
                this.form_data_special_tech.page = page
                this.getSpecialTechList()
            },
            search_special_tech() {
                this.getSpecialTechList();
            },
            toggle_special_tech(v) {
                if(this.form_data.special_tech.includes(v.id)) {
                    this.$DModal.confirm({
                        content: 'Do you want to cancel this data entry?',
                        okText:'Confirm',
                        cancelText:'Cancel',
                        onOK: async () => {
                            this.$store.commit('design/update_special_tech', v.id)
                        }
                    })
                } else {
                    this.$store.commit('design/update_special_tech', v.id)
                }
            },
            add_tech() {
                let object = {image: "", content: "", raw: "", raw_name: "",}
                this.$store.commit("design/arr_push_one", {key: 'tech', value: object})
            },
            del_tech(k) {
                this.$DModal.confirm({
                    content: 'Do you want to cancel this data?',
                    okText:'Confirm',
                    cancelText:'Cancel',
                    onOK: async () => {
                        this.$store.commit('design/arr_remove_one', {key: 'tech', index: k})
                    }
                })
            },
            open_tech_detail(v) {
                console.log('techdetail',v);
                this.current_temp_special_tech = v;
                this.is_popup_show_detail = true;
            },
            close_tech_detail() {
                this.reset_temp_special_tech()
                this.is_popup_show_detail = false;
            },
            reset_temp_special_tech() {
                this.current_temp_special_tech = {image_list: []};
            },
            input($event, field, k) {
                let object = this.form_data[field][k]
                object.content = $event.target.value
                this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
            },
            onBeforeUpload(file, field, k, child_field) {
                uploadFileToOSS(file, 'template').then(url => {
                    let object = this.form_data[field][k]
                    if (child_field === "file") {
                        object.raw = url;
                        object.raw_name = file.name;
                    } else if (child_field === "image") {
                        object.image = url;
                    }
                    this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
                })
                return false;
            },
            async getSpecialTechList() {
                return GetSpecialTech({
                    ...this.form_data_special_tech,
                }).then((response) => {
                    this.special_tech_list = response.data.list;
                    this.total = response.data.total;
                    return response;
                });
            },
        },
        mounted() {
            this.width = window.innerWidth - 220 - 490 - 30 + 'px'
        }
    }
</script>

<style lang="scss" scoped>
    .inner-wrap {
        display: flex;
        flex-wrap: nowrap;
        .left {
            padding: 0 30px 100px 30px;
            width: 490px;
            background: white;
            overflow: auto;
            h1 {
                width: 100%;
                height: 20px;
                line-height: 20px;
                font-size: 17px;
                color: #000000;
                border-left: 2px solid black;
                padding-left: 10px;
                margin: 15px 0;
            }

            .tip {
                font-size: 13px;
                text-align: center;
            }
            .tech-list {
                display: flex;
                flex-wrap: wrap;
                align-content: flex-start;

                .tech-item {
                    height: 28px;
                    padding: 0 5px;
                    display: flex;
                    flex-wrap: nowrap;
                    align-items: center;
                    background: #F8F9FC;
                    margin: 5px 10px;
                    text-align: center;
                    border-radius: 4px;
                    border: 1px solid #E2E3E5;
                    .check {
                        margin: 0 3px;
                        width: 15px;
                        height: 15px;
                    }
                    .money {
                        color: #FA3D5A;
                    }
                }

                .tech-item.active {
                    background: #000000;
                    color: white;

                    .money {
                        color: white;
                    }
                }
            }
            .item {
                position: relative;
                width: 440px;
                padding: 10px;
                margin-bottom: 25px;
                background: #FAFAFA;
                .upload-wrap {
                    width: 418px;
                    height: 140px;
                    display: flex;
                    flex-wrap: wrap;
                    align-content: center;
                    justify-content: center;
                    .icon-upload {
                        width: 24px;
                        height: 24px;
                    }
                    p {
                        width: 100%;
                        margin-top: 5px;
                        color: #FA3D5A;
                        text-align: center;
                    }
                }
                .doc-file{
                    display:flex;
                    align-items:center;
                    .doc-wrap {
                        display: flex;
                        flex-wrap: nowrap;
                        align-items: center;
                        .icon-doc {
                            width: 24px;
                            height: 24px;
                            margin:0 10px;
                        }
                    }
                    .replace-file{
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        width:100px;
                        background:rgba(0,0,0,0.4);
                        color:#ffffff;
                        font-size:13px;
                        cursor:pointer;
                        .ico{
                            width:18px;
                            height:18px;
                        }
                    }
                }
                .bz {
                    background: white;
                    display: flex;
                    flex-wrap: nowrap;
                    align-items: center;
                    height: 50px;
                    margin-top: 16px;
                    label {
                        font-size: 13px;
                        margin-left: 10px;
                    }
                    input {
                        height: 50px;
                        line-height: 50px;
                        background: white;
                        border: none;
                        outline: none;
                    }
                }

                .icon-del {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 25px;
                    height: 25px;
                    z-index: 100;
                }

                .btn-re {
                    position: absolute;
                    top: 10px;
                    right: 40px;
                    z-index: 1000;
                    font-size: 14px;
                }
                .image-box{
                    width:400px;
                    height:100px;
                    position:relative;
                    .replace-btn{
                        width:100px;
                        position:absolute;
                        bottom:11px;
                        left:50%;
                        transform:translateX(-50%);
                        background:rgba(0,0,0,0.4);
                        color:#ffffff;
                        font-size:13px;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        cursor:pointer;
                        .ico{
                            width:18px;
                            height:18px;
                            // color:#ffffff;
                        }
                        .text{}
                    }
                }
            }

            .btn-continue {
                width: 420px;
                height: 55px;
                line-height: 55px;
                color: #666666;
                font-size: 14px;
                text-align: center;
                margin: 10px 0;
                border-radius: 10px;
                border: 1px solid #ccc;
            }
        }

        .right {
            margin: 0 auto;
            .material-wrap {
                margin-top: 10px;
                margin-right: 50px;
                padding: 10px;
                background: white;
                .top {
                    display: flex;
                    justify-content: space-between;
                    padding-bottom: 5px;
                    border-bottom: 2px solid #f6f7fa;
                    h2 {
                        font-size: 20px;
                        color: #1a1a1a;
                        white-space: nowrap;
                    }

                    .input-wrap {
                        margin-left: 50px;
                        width: 280px;
                        height: 35px;
                        position: relative;

                        &:focus {
                            border: none !important;
                        }

                        &::after {
                            border: none !important;
                        }

                        input {
                            width: 100%;
                            height: 100%;
                            background: #f2f2f2;
                            border-radius: 17px;
                            padding: 0 45px 0 20px;
                            border: none !important;

                            &:focus {
                                border: none !important;
                            }

                            &::after {
                                border: none !important;
                            }
                        }

                        .icon-search {
                            position: absolute;
                            right: 18px;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 20px;
                            height: 20px;
                            cursor: pointer;
                        }
                    }
                }

                /* 主内容区 */
                .content {
                    display: flex;

                    /* 左侧分类 */
                    .category-list {
                        width: 100px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        align-content: flex-start;
                        border-right: 1px solid #f6f7fa;
                        overflow-y: auto;
                        padding: 15px 0;

                        .category-item {
                            width: 80px;
                            height: 35px;
                            line-height: 35px;
                            text-align: center;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #1C1C1C;
                            border-radius: 5px;
                            &.active {
                                background: #1C1C1C;
                                color: white;
                                font-weight: 500;
                            }
                        }
                    }

                    /* 右侧内容 */
                    .right {
                        $left_width: 140px;
                        width: calc(100% - #{$left_width});
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        padding: 10px;
                        overflow: hidden;

                        /* 标签筛选区 */
                        .label-list {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 12px 0;
                            margin-bottom: 5px;

                            .label-item {
                                padding: 0 15px;
                                height: 30px;
                                line-height: 30px;
                                border-radius: 15px;
                                //   background: #f6f6f6;
                                cursor: pointer;
                                transition: all 0.2s;

                                &.active {
                                    background: #ffecee;
                                    color: #fa3d5a;
                                    font-weight: 500;
                                }
                            }
                        }

                        /* 子分类 */
                        .sub-list {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 10px;
                            margin-top: 10px;
                            margin-bottom: 10px;
                            background: #f6f6f6;

                            .sub-item {
                                padding: 0 12px;
                                height: 28px;
                                line-height: 28px;
                                border-radius: 14px;
                                cursor: pointer;
                                transition: all 0.2s;

                                &.active {
                                    background: #fa3d5a;
                                    color: white;
                                }
                            }
                        }
                        .no-data {
                            width:300px;
                            height: auto;
                            display: block;
                            margin:0 auto;
                        }
                        .fabric-list {
                            flex: 1;
                            display: grid;
                            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
                            border-radius: 5px;
                            // gap: 3px 0px;
                            gap: 6px 55px;
                            align-items: start;
                            overflow-y: auto;
                            padding: 15px;
                            height:auto;
                            max-height:650px;
                            background: #F6F7FA;

                            &::-webkit-scrollbar {
                                display: none !important;
                            }

                            .fabric-item {
                                position: relative;
                                // width: 142px;
                                flex:0 0 20%;
                                height: 175px;
                                margin: 0 5px 15px 5px;
                                cursor: pointer;
                                box-sizing: border-box;
                                border: 1px solid #e3e4e6;
                                border-radius: 5px;

                                img {
                                    // width: 140px;
                                    width:100%;
                                    height: 141px;
                                    border-top-left-radius: 5px;
                                    border-top-right-radius: 5px;
                                    object-fit: contain;
                                }

                                p {
                                    // width: 140px;
                                    width: 100%;
                                    height: 30px;
                                    line-height: 30px;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    background: white;
                                    padding: 0 5px;
                                    border-top: 0.5px solid #e3e4e6;
                                    margin-top: -5px;
                                    text-align: center;
                                    border-bottom-left-radius: 5px;
                                    border-bottom-right-radius: 5px;
                                }

                                .icon-check {
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    width: 25px;
                                    height: 25px;
                                }

                                &.active {
                                    border: 1px solid #fa3d5a;
                                }

                                .mask {
                                    display: none;
                                }

                                &:hover {
                                    .mask {
                                        display: block;
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        right: 0;
                                        height: 140px;
                                        z-index: 100;
                                        background: rgba(0, 0, 0, 0.35);
                                        
                                        .btn{
                                            display:flex;
                                            align-items:center;
                                            justify-content: end;
                                            position: absolute;
                                            right: 10px;
                                            top: 115px;
                                            column-gap:10px;
                                            .fa-detail {
                                                z-index: 101;
                                                color: white;
                                                font-weight: bold;
                                            }

                                            .fa-choose {
                                                z-index: 101;
                                                color: white;
                                                font-weight: bold;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        /* 底部按钮 */
                        .btn-group {
                            display: flex;
                            justify-content: flex-end;
                            gap: 15px;
                            padding-top: 10px;

                            .btn {
                                min-width: 100px;
                                height: 38px;
                                line-height: 38px;
                                border-radius: 5px;
                                cursor: pointer;
                                transition: all 0.2s;
                                text-align: center;

                                &.btn-cancel {
                                    color: black;
                                    border: 1px solid #e5e5e5;
                                }

                                &.btn-confirm {
                                    color: white;
                                    background: #fa3d5a;
                                }
                            }
                        }
                    }
                }

                .color-mask {
                    position: absolute;
                    top: 0;
                    right: 0;
                    left: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.35);
                    z-index: 9999;
                    .color-wrap {
                        position: absolute;
                        width: 600px;
                        height: 300px;
                        top:calc(50% - 150px);
                        left: calc(50% - 300px);
                        background: white;
                        border-radius: 10px;
                        z-index: 10000;
                        padding: 20px 10px 0 10px;

                        .title {
                            font-size: 16px;
                            font-weight: bold;
                            color: #1a1a1a;
                        }

                        .color-list {
                            display: flex;
                            flex-wrap: wrap;
                            width: 560px;
                            min-height: 150px;

                            .color-item {
                                width: 120px;
                                height: 46px;
                                border: 1px solid #e5e5e5;
                                border-radius: 5px 5px 5px 5px;
                                margin: 0 8px;
                                display: flex;
                                align-items: center;
                                padding: 0 5px;
                                cursor: pointer;

                                img {
                                    width: 30px;
                                    height: 30px;
                                    margin-right: 5px;
                                }

                                &.active {
                                    border-color: #fa3d5a;

                                    span {
                                        color: #fa3d5a;
                                    }
                                }
                            }
                        }

                        .btn-group {
                            margin-top: 24px;
                            display: flex;
                            justify-content: flex-end;
                            align-items: center;
                            border-top: 1px solid #e5e5e5;
                            height: 58px;

                            .btn {
                                width: 100px;
                                height: 38px;
                                line-height: 38px;
                                border-radius: 5px;
                                text-align: center;
                                font-size: 14px;
                                margin: 0 7px;
                                cursor: pointer;

                                &.btn-cancel {
                                    color: black;
                                    border: 1px solid #e5e5e5;
                                }

                                &.btn-confirm {
                                    color: white;
                                    background: #fa3d5a;
                                }
                            }
                        }
                    }
                }
            }
        }

        ::v-deep .popup-modal {
            /* 核心容器 */
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 999;
            background: rgba(0, 0, 0, 0.6);

            /* 弹窗内容区 */
            .popup-content {
                background: #fff;
                border-radius: 10px;
                //   width: min(980px, 92vw); // 最大980px，最小占92%视口宽
                /* 修正后 */
                width: max(980px, 96vw); // 增加视口占比
                min-width: 320px; // 保障最小可操作宽度
                max-width: none !important; // 移除潜在限制

                /* 添加边距保护 */
                margin: 0 2vw; // 左右留白
                box-sizing: content-box; // 防止padding影响
                max-height: max(720px, 85vh); // 最大720px，最小占85%视口高
                height: 30vh;
                display: flex;
                flex-direction: column;
                overflow: hidden;
            }
        }

        .fabric-content-wrap {
            margin-top: 40px;
            display: flex;
            flex-direction: column;
            height: 600px; // 整体容器高度

            .title {
                color: #1a1a1a;
                font-size: 16px;
                border-left: none;
                font-weight: bold;
                padding: 10px 0;
                padding-bottom: 16px;
                border-bottom: 1px solid #e5e5e5;
                text-align: center;
                flex-shrink: 0; // 固定高度不被压缩
            }

            .content-scroll {
                flex: 1;
                overflow-y: auto;
                padding: 20px 0;
                display: flex;
                flex-direction: column;

                .info-wrap,
                .richtext-wrap {
                    flex-shrink: 0;
                }

                .info-wrap {
                    display: flex;
                    justify-content: space-around;
                    .left {
                        width: 420px;
                        .f-img {
                            width: 420px;
                            height: 420px;
                        }
                    }

                    .right {
                        width: 500px;
                        .name {
                            color: #1a1a1a;
                            font-size: 20px;
                        }

                        .no {
                            color: #808080;
                            font-size: 14px;
                            margin: 25px 0;
                        }

                        .item {
                            margin: 5px 0;
                            .key {
                                display: inline-block;
                                color: #808080;
                                width: 80px;
                            }

                            .value {
                                color: #1a1a1a;
                            }
                        }
                    }
                }

                .richtext-wrap {
                    padding-top: 20px;
                }
            }
        }

        .slider {
            width: 420px;
            height: 420px;
            overflow: hidden;

            .swiper-slide {
                width: 420px;
                height: 420px;
            }

            .img {
                width: 420px;
                height: 420px;
            }
        }
    }
    @media (min-width:1280px) and (max-width:1679px){
        .inner-wrap{
            min-width:1200px;
            height:100%;
            overflow:visible;
            .left{
                flex-shrink:0;
                width:auto;
                min-width:400px;
                max-width:450px;
                margin-right:10px;
                height:100% !important;
                .btn-continue{
                    width:auto;
                    max-width:450px;
                }
                .item{
                    width:100%;
                }
            }
            .right{
                margin:0;
                // width:auto !important;
                flex:1 1 auto;
                // min-width:600px;
                // max-width:1100px;
                flex-shrink:0;
                margin-right:0;
                height:100%;
                .material-wrap{
                    width:100%;
                }
            }
        }
    }
    @media (max-width:1279px){
        .inner-wrap{
            min-width:1200px;
            height:100%;
            overflow:visible;
            .left{
                flex-shrink:0;
                width:auto;
                min-width:400px;
                max-width:450px;
                margin-right:10px;
                height:100% !important;
                .btn-continue{
                    width:auto;
                    max-width:450px;
                }
                .item{
                    width:100%;
                }
            }
            .right{
                margin:0;
                // width:auto !important;
                flex:1 1 auto;
                // min-width:600px;
                // max-width:500px;
                flex-shrink:0;
                margin-right:0;
                height:100%;
                .material-wrap{
                    width:100%;
                }
            }
        }
    }
</style>

